const WEB_CSS_CLASSNAMES = {
    BODY1: 'body1 body',
    BODY2: 'body2 body',
    FINEPRINT: 'fineprint smallprint',
    HEADING1: 'heading1 headline1 title__primary',
    HEADING2: 'heading2 headline2 title__secondary',
    HEADING3: 'heading3 headline3 title__tertiary',
    HEADING4: 'heading4 headline4 title__quaternary',
    HEADING5: 'heading5 headline5 title__quinary',
    HEADING6: 'heading6 headline6',
    SUBHEADING1: 'subheading1 subheadline1 subtitle1 title__subtitle',
    SUBHEADING2: 'subheading2 subheadline2 subtitle2 title__subtitle',
};

export default WEB_CSS_CLASSNAMES;
